import {
  isAnalysisBidOrg,
  isAnalysisCompanyOrg,
  isAnalysisLaborOrg
} from '@/utils/analysisMenu'

export function isAiAssistantPage(item) {
  if (!item) return false
  if (item.name === 'aiWorkbench' || item.name === 'aiPreClass') return true
  if (item.pageCode === 'aiWorkbench' || item.pageCode === 'aiPreClass') return true
  const title = pageTitle(item)
  if (title === '筑蜂智能助手' || title === 'AI工作台') return true
  const path = pagePath(item)
  return path === '/aiWorkbench' || path.indexOf('/aiWorkbench?') === 0
}

export function stripAiAssistantMenuPages(pages) {
  return stripPages(pages, isAiAssistantPage)
}

const HIDDEN_NAMES = ['monitoring', 'todoTask', 'workbench']
const HIDDEN_TITLES = ['监控中心', '待办任务', '代办任务', '业务工作台']
const REMOVED_NAMES = ['ruleSetting', 'technologicalProcess', 'organUser']
const REMOVED_TITLES = ['规则设置', '工艺工序', '机构用户列表']
const REMOVED_APPLET_TITLES = ['考勤统计', '薪酬发放']
const PRECLASS_ANALYSIS_NAMES = ['preClassCompanyData', 'preClassBidData']

function pageTitle(item) {
  if (!item) return ''
  if (item.pageName) return item.pageName
  if (item.meta && item.meta.title) return item.meta.title
  return ''
}

function pagePath(item) {
  return (item && (item.path || item.pageUrl)) || ''
}

function pageRouteName(item) {
  if (!item) return ''
  if (item.name && PRECLASS_ANALYSIS_NAMES.indexOf(item.name) >= 0) return item.name
  if (item.pageCode && PRECLASS_ANALYSIS_NAMES.indexOf(item.pageCode) >= 0) {
    return item.pageCode
  }
  const path = pagePath(item)
  if (path.indexOf('preClassBidData') >= 0) return 'preClassBidData'
  if (path.indexOf('preClassCompanyData') >= 0) return 'preClassCompanyData'
  return item.name || item.pageCode || ''
}

export function isPlatformHiddenPage(item) {
  if (!item) return false
  // 资料库/试卷库/试题库虽挂在 /workbench 路径下，但是顶级系统页，不能当工作台隐藏项剥掉
  if (isNavLibraryPage(item)) return false
  if (HIDDEN_NAMES.indexOf(item.name) >= 0) return true
  if (HIDDEN_TITLES.indexOf(pageTitle(item)) >= 0) return true
  const path = pagePath(item)
  if (!path) return false
  if (path === '/monitoring' || path.indexOf('/monitoring/') === 0) return true
  if (path === '/todoTakas' || path === '/todoTask') return true
  if (path === '/workbench' || path.indexOf('/workbench/') === 0) return true
  return false
}

export function isRemovedPage(item) {
  if (!item) return false
  if (REMOVED_NAMES.indexOf(item.name) >= 0) return true
  if (REMOVED_TITLES.indexOf(pageTitle(item)) >= 0) return true
  const path = pagePath(item)
  if (!path) return false
  if (path === '/systemSettings/ruleSetting' || path.indexOf('/systemSettings/ruleSetting/') === 0) {
    return true
  }
  if (
    path === '/systemSettings/technologicalProcess' ||
    path.indexOf('/systemSettings/technologicalProcess/') === 0
  ) {
    return true
  }
  if (path === '/userRights/user/organUser' || path.indexOf('/userRights/user/organUser') === 0) {
    return true
  }
  return false
}

function appletPath(item) {
  return (item && (item.pagePath || item.path || item.pageUrl)) || ''
}

export function isRemovedAppletPage(item) {
  if (!item) return false
  const path = appletPath(item)
  if (path.indexOf('/workbench/') >= 0) return false
  if (REMOVED_APPLET_TITLES.indexOf(pageTitle(item)) >= 0) return true
  if (path.indexOf('/pages/workTime/census') >= 0) return true
  if (path.indexOf('/pages/salary/census') >= 0) return true
  return false
}

function stripPages(pages, predicate) {
  if (!Array.isArray(pages)) return []
  return pages
    .filter((item) => !predicate(item))
    .map((item) => {
      const next = Object.assign({}, item)
      if (next.children && next.children.length) {
        next.children = stripPages(next.children, predicate)
      }
      return next
    })
}

export function stripPlatformHiddenPages(pages) {
  return stripPages(pages, isPlatformHiddenPage)
}

export function stripRemovedPages(pages) {
  return stripPages(pages, isRemovedPage)
}

export function isDomainBrandPage(item) {
  if (!item) return false
  if (item.name === 'domainBrand') return true
  if (pageTitle(item) === '域名配置') return true
  return pagePath(item) === '/systemSettings/domainBrand'
}

function isSystemSettingsPage(item) {
  if (!item) return false
  if (item.name === 'systemSettings') return true
  if (pageTitle(item) === '系统设置') return true
  const path = pagePath(item)
  return path === '/systemSettings' || path === '/systemSettings/'
}

function domainBrandMenuItem() {
  return {
    name: 'domainBrand',
    path: '/systemSettings/domainBrand',
    pageName: '域名配置',
    hidden: false,
    index: 999,
    meta: { icon: 'el-icon-link', title: '域名配置' },
    children: []
  }
}

function findSystemSettings(pages) {
  if (!Array.isArray(pages)) return null
  const top = pages.find(isSystemSettingsPage)
  if (top) return top
  for (let i = 0; i < pages.length; i++) {
    const children = pages[i] && pages[i].children
    if (!children || !children.length) continue
    const nested = children.find(isSystemSettingsPage)
    if (nested) return nested
  }
  return null
}

export function stripDomainBrandFromRoleTree(pages) {
  return stripPages(pages, isDomainBrandPage)
}

export function ensureDomainBrandPage(pages) {
  if (!Array.isArray(pages)) return pages
  const next = pages.map((item) => {
    const copy = Object.assign({}, item)
    if (copy.children && copy.children.length) {
      copy.children = copy.children.slice()
    }
    return copy
  })
  const settings = findSystemSettings(next)
  if (!settings) {
    if (!next.some(isDomainBrandPage)) {
      next.push(domainBrandMenuItem())
    }
    return next
  }
  if (!settings.children) settings.children = []
  const exists = settings.children.some((item) => isDomainBrandPage(item))
  if (!exists) {
    settings.children.push(domainBrandMenuItem())
  }
  return next
}

function isRuleConfigPage(item) {
  if (!item) return false
  if (item.name === 'systemRuleConfig') return true
  if (pageTitle(item) === '规则配置') return true
  return pagePath(item) === '/systemSettings/ruleConfig'
}

function ruleConfigMenuItem() {
  return {
    name: 'systemRuleConfig',
    path: '/systemSettings/ruleConfig',
    pageName: '规则配置',
    hidden: false,
    index: 998,
    meta: { icon: 'el-icon-set-up', title: '规则配置' },
    children: []
  }
}

/** 超管菜单：规则配置（仅 dpnadmin 可见） */
export function ensureRuleConfigPage(pages) {
  if (!Array.isArray(pages)) return pages
  const next = pages.map((item) => {
    const copy = Object.assign({}, item)
    if (copy.children && copy.children.length) {
      copy.children = copy.children.slice()
    }
    return copy
  })
  const settings = findSystemSettings(next)
  if (!settings) {
    if (!next.some(isRuleConfigPage)) {
      next.push(ruleConfigMenuItem())
    }
    return next
  }
  if (!settings.children) settings.children = []
  const exists = settings.children.some((item) => isRuleConfigPage(item))
  if (!exists) {
    settings.children.push(ruleConfigMenuItem())
  }
  return next
}

function isNavLibraryPage(item) {
  return isMaterialLibraryPage(item) || isExamLibraryPage(item)
}

export function isMaterialLibraryPage(item) {
  if (!item) return false
  if (item.name === 'materialLibrary') return true
  if (pageTitle(item) === '资料库') return true
  return pagePath(item) === '/workbench/materialLibrary'
}

function pageTreeHas(pages, predicate) {
  if (!Array.isArray(pages) || !predicate) return false
  const stack = pages.slice()
  while (stack.length) {
    const item = stack.shift()
    if (!item) continue
    if (predicate(item)) return true
    const children = item.children
    if (children && children.length) {
      for (let i = 0; i < children.length; i++) stack.push(children[i])
    }
  }
  return false
}

function materialLibraryMenuItem(index) {
  return {
    name: 'materialLibrary',
    path: '/workbench/materialLibrary',
    pageName: '资料库',
    hidden: false,
    index: index != null ? index : 81,
    meta: { icon: 'el-icon-notebook-2', title: '资料库' }
  }
}

export function stripMaterialLibraryFromRoleTree(pages) {
  return stripPages(pages, isMaterialLibraryPage)
}

/** 超管菜单：资料库缺失时补上（不改已有项顺序，由 index 排序） */
export function ensureMaterialLibraryPage(pages) {
  if (!Array.isArray(pages)) return pages
  if (pageTreeHas(pages, isMaterialLibraryPage)) return pages
  const next = cloneMenuTree(pages)
  const report = findDataReport(next)
  const base =
    report && report.index != null && report.index !== ''
      ? Number(report.index) + 1
      : 81
  next.push(materialLibraryMenuItem(base))
  return next
}

export function isPaperLibraryPage(item) {
  if (!item) return false
  if (item.name === 'paperLibrary') return true
  if (pageTitle(item) === '试卷库') return true
  return pagePath(item) === '/workbench/paperLibrary'
}

export function isQuestionLibraryPage(item) {
  if (!item) return false
  if (item.name === 'questionLibrary') return true
  if (pageTitle(item) === '试题库') return true
  return pagePath(item) === '/workbench/questionLibrary'
}

export function isExamLibraryPage(item) {
  return isPaperLibraryPage(item) || isQuestionLibraryPage(item)
}

function paperLibraryMenuItem(index) {
  return {
    name: 'paperLibrary',
    path: '/workbench/paperLibrary',
    pageName: '试卷库',
    hidden: false,
    index: index != null ? index : 82,
    meta: { icon: 'el-icon-document', title: '试卷库' }
  }
}

function questionLibraryMenuItem(index) {
  return {
    name: 'questionLibrary',
    path: '/workbench/questionLibrary',
    pageName: '试题库',
    hidden: false,
    index: index != null ? index : 83,
    meta: { icon: 'el-icon-collection', title: '试题库' }
  }
}

export function stripExamLibraryFromRoleTree(pages) {
  return stripPages(pages, isExamLibraryPage)
}

/** 超管菜单：试卷库/试题库缺失时补上（不改已有项顺序） */
export function ensureExamLibraryPages(pages) {
  if (!Array.isArray(pages)) return pages
  const needPaper = !pageTreeHas(pages, isPaperLibraryPage)
  const needQuestion = !pageTreeHas(pages, isQuestionLibraryPage)
  if (!needPaper && !needQuestion) return pages
  const next = cloneMenuTree(pages)
  let base = 82
  const material = next.find(isMaterialLibraryPage)
  const report = findDataReport(next)
  if (material && material.index != null && material.index !== '') {
    base = Number(material.index) + 1
  } else if (report && report.index != null && report.index !== '') {
    base = Number(report.index) + 2
  }
  if (needPaper) next.push(paperLibraryMenuItem(base))
  if (needQuestion) next.push(questionLibraryMenuItem(base + (needPaper ? 1 : 0)))
  return next
}

export function isReportTemplateConfigPage(item) {
  if (!item) return false
  if (item.name === 'reportTemplate') return true
  if (pageTitle(item) === '报表模板') return true
  return pagePath(item) === '/dataReport/reportTemplate'
}

function isDataReportPage(item) {
  if (!item) return false
  if (item.name === 'dataReport') return true
  if (pageTitle(item) === '数据报表') return true
  return pagePath(item) === '/dataReport'
}

function isRealnameReportPage(item) {
  if (!item) return false
  if (item.name === 'proRealnameReport') return true
  const path = pagePath(item)
  if (path === '/dataReport/ProRealnameReport' || path.indexOf('/dataReport/ProRealname') >= 0) {
    return true
  }
  const title = pageTitle(item)
  if (title === '实名制报表' || title === '劳务用工报表') return true
  return title === '劳务用工' && path.indexOf('/dataReport') >= 0
}

function preClassEduReportMenuItem() {
  return {
    name: 'preClassEduReport',
    path: '/dataReport/preClassEduReport',
    pageName: '班前教育',
    hidden: false,
    index: 81,
    meta: { icon: 'iconfont icon-order-fill', title: '班前教育' },
    children: []
  }
}

export function isPreClassEduReportPage(item) {
  if (!item) return false
  if (item.name === 'preClassEduReport') return true
  const path = pagePath(item)
  if (path === '/dataReport/preClassEduReport' || path.indexOf('preClassEduReport') >= 0) {
    return true
  }
  const title = pageTitle(item)
  if (title === '班前教育报表') return true
  return title === '班前教育' && path.indexOf('/dataReport') >= 0
}

export function pageTreeHasDataReport(pages) {
  if (!Array.isArray(pages)) return false
  const stack = pages.slice()
  while (stack.length) {
    const item = stack.shift()
    if (!item) continue
    if (isDataReportPage(item) || isPreClassEduReportPage(item)) return true
    const children = item.children
    if (children && children.length) {
      for (let i = 0; i < children.length; i++) stack.push(children[i])
    }
  }
  return false
}

export function hasDataReportPermission(params) {
  const getters = (params && params.getters) || {}
  const state = (params && params.state) || {}
  const user = state.user || {}
  if (pageTreeHasDataReport(getters['user/pages'])) return true
  if (pageTreeHasDataReport(getters['user/menuPages'])) return true
  const orgUid = (params && params.orgValue) || user.orgValue
  const orgPages =
    (user.userPages || []).find((item) => item && item.orgUid === orgUid) || {}
  return pageTreeHasDataReport(orgPages.pages)
}

function realnameReportMenuItem() {
  return {
    name: 'proRealnameReport',
    path: '/dataReport/ProRealnameReport',
    pageName: '劳务用工',
    hidden: false,
    index: 1,
    meta: { icon: 'iconfont icon-order-fill', title: '劳务用工' },
    children: []
  }
}

function dataReportMenuItem(children) {
  return {
    name: 'dataReport',
    path: '/dataReport',
    pageName: '数据报表',
    hidden: false,
    index: 80,
    meta: { icon: 'iconfont icon-order-fill', title: '数据报表' },
    children: children || []
  }
}

function findDataReport(pages) {
  if (!Array.isArray(pages)) return null
  const top = pages.find(isDataReportPage)
  if (top) return top
  for (let i = 0; i < pages.length; i++) {
    const children = pages[i] && pages[i].children
    if (!children || !children.length) continue
    const nested = children.find(isDataReportPage)
    if (nested) return nested
  }
  return null
}

function cloneMenuTree(pages) {
  if (!Array.isArray(pages)) return []
  return pages.map((item) => {
    const copy = Object.assign({}, item)
    if (copy.children && copy.children.length) {
      copy.children = copy.children.slice()
    }
    return copy
  })
}

export function stripReportTemplateConfigFromRoleTree(pages) {
  return stripPages(pages, isReportTemplateConfigPage)
}

export function ensurePreClassEduReportPage(pages) {
  if (!Array.isArray(pages)) return pages
  const next = cloneMenuTree(pages)
  const parent = findDataReport(next)
  if (parent) {
    if (!parent.children) parent.children = []
    if (!parent.children.some(isPreClassEduReportPage)) {
      parent.children.push(preClassEduReportMenuItem())
    }
    return next
  }
  const realnameIndex = next.findIndex(isRealnameReportPage)
  if (realnameIndex >= 0) {
    const realname = next[realnameIndex]
    next.splice(realnameIndex, 1, dataReportMenuItem([realname, preClassEduReportMenuItem()]))
    return next
  }
  return next
}

export function ensureDataReportMenu(pages) {
  if (!Array.isArray(pages)) return pages
  const next = cloneMenuTree(pages)
  let parent = findDataReport(next)
  if (!parent) {
    const realnameIndex = next.findIndex(isRealnameReportPage)
    const realname = realnameIndex >= 0 ? next[realnameIndex] : realnameReportMenuItem()
    if (realnameIndex >= 0) {
      next.splice(realnameIndex, 1)
    }
    parent = dataReportMenuItem([realname])
    next.push(parent)
  }
  if (!parent.children) parent.children = []
  if (!parent.children.some(isRealnameReportPage)) {
    parent.children.unshift(realnameReportMenuItem())
  }
  if (!parent.children.some(isPreClassEduReportPage)) {
    parent.children.push(preClassEduReportMenuItem())
  }
  return next
}

export function stripRemovedAppletPages(pages) {
  return stripPages(pages, isRemovedAppletPage)
}

export function isReportTemplatePage(item) {
  if (!item) return false
  const meta = item.meta || {}
  return !!(meta.reportUid || meta.reportTemplate)
}

export function stripReportTemplatePages(pages) {
  return stripPages(pages, isReportTemplatePage)
}

export function mergeReportGroups(pageGroups, apiGroups) {
  const groups = {}
  const pushGroup = (group) => {
    if (!group) return
    const code = group.code || 'findReport'
    if (!groups[code]) {
      groups[code] = {
        code: code,
        name: group.name || group.templateGroupName || '报表',
        reports: []
      }
    } else if (group.name && !groups[code].name) {
      groups[code].name = group.name
    }
    const seen = {}
    groups[code].reports.forEach((item) => {
      seen[item.code || item.uid] = true
    })
    ;(group.reports || []).forEach((item) => {
      if (!item) return
      const key = item.code || item.uid
      if (!key || seen[key]) return
      seen[key] = true
      groups[code].reports.push(item)
    })
  }
  ;(pageGroups || []).forEach(pushGroup)
  ;(apiGroups || []).forEach(pushGroup)
  return Object.keys(groups).map((key) => groups[key])
}

export function collectReportTemplates(pages) {
  const groups = {}
  const walk = (list, parent) => {
    const rows = list || []
    rows.forEach((item) => {
      if (!item) return
      const meta = item.meta || {}
      if (meta.reportUid) {
        const code =
          meta.reportGroup ||
          (parent && (parent.name || parent.pageCode)) ||
          'managerReport'
        const name =
          meta.reportGroupName ||
          (parent && (parent.pageName || (parent.meta && parent.meta.title))) ||
          '报表'
        if (!groups[code]) {
          groups[code] = { code: code, name: name, reports: [] }
        }
        groups[code].reports.push({
          uid: meta.reportUid,
          name: item.pageName || meta.title || item.name || '',
          code: meta.reportCode || item.name || item.pageCode || '',
          sort: item.index,
          type: meta.reportType || 'defaultreport'
        })
      }
      if (item.children && item.children.length) {
        walk(item.children, item)
      }
    })
  }
  walk(pages, null)
  return Object.keys(groups).map((key) => groups[key])
}

export function keepPreClassAnalysisName(roleCode, orgType) {
  if (isAnalysisLaborOrg(orgType) || isAnalysisBidOrg(orgType)) {
    return 'preClassBidData'
  }
  if (isAnalysisCompanyOrg(orgType)) {
    return 'preClassCompanyData'
  }
  if (roleCode === 'project_admin' || roleCode === 'labor_admin') {
    return 'preClassBidData'
  }
  return 'preClassCompanyData'
}

function hasPreClassRoute(pages, routeName) {
  if (!Array.isArray(pages) || !routeName) return false
  for (let i = 0; i < pages.length; i++) {
    const item = pages[i]
    if (pageRouteName(item) === routeName) return true
    if (hasPreClassRoute(item.children, routeName)) return true
  }
  return false
}

const PRECLASS_PATH = {
  preClassCompanyData: '/analysis/preClassCompanyData',
  preClassBidData: '/analysis/preClassBidData'
}

function rewritePreClassAnalysisPages(pages, toName) {
  if (!Array.isArray(pages) || !toName) return pages
  const toPath = PRECLASS_PATH[toName]
  if (!toPath) return pages
  return pages.map((item) => {
    const next = Object.assign({}, item)
    const routeName = pageRouteName(item)
    if (PRECLASS_ANALYSIS_NAMES.indexOf(routeName) >= 0 && routeName !== toName) {
      next.name = toName
      next.pageCode = toName
      const path = pagePath(item)
      const orgUidMatch = String(path).match(/\/([0-9a-fA-F-]{36})$/)
      next.path = orgUidMatch ? toPath + '/' + orgUidMatch[1] : toPath
    }
    if (next.children && next.children.length) {
      next.children = rewritePreClassAnalysisPages(next.children, toName)
    }
    return next
  })
}

export function stripDuplicatePreClassAnalysis(pages, roleCode, orgType) {
  const keep = keepPreClassAnalysisName(roleCode, orgType)
  if (!hasPreClassRoute(pages, keep)) {
    const other =
      keep === 'preClassBidData' ? 'preClassCompanyData' : 'preClassBidData'
    if (hasPreClassRoute(pages, other)) {
      return rewritePreClassAnalysisPages(pages, keep)
    }
    return pages
  }
  return stripPages(pages, (item) => {
    const routeName = pageRouteName(item)
    if (PRECLASS_ANALYSIS_NAMES.indexOf(routeName) < 0) return false
    return routeName !== keep
  })
}

const ANALYSIS_ORG_PAGE_NAMES = [
  'proRealnameData',
  'officialCarData',
  'preClassCompanyData',
  'preClassBidData',
  'materialData'
]

function alreadyHasOrgUid(path, orgUid) {
  if (!path || !orgUid) return false
  const suffix = '/' + orgUid
  return path.length >= suffix.length && path.slice(-suffix.length) === suffix
}

function appendOrgUidPath(path, orgUid) {
  if (!path || !orgUid) return path
  if (alreadyHasOrgUid(path, orgUid)) return path
  return path + '/' + orgUid
}

export function isAnalysisOrgPage(item) {
  if (!item) return false
  if (ANALYSIS_ORG_PAGE_NAMES.indexOf(item.name) >= 0) return true
  if (ANALYSIS_ORG_PAGE_NAMES.indexOf(item.pageCode) >= 0) return true
  const path = pagePath(item)
  return ANALYSIS_ORG_PAGE_NAMES.some((name) => path.indexOf('/' + name) >= 0)
}

export function appendOrgUidToAnalysisPages(pages, orgUid) {
  if (!Array.isArray(pages) || !orgUid) return pages
  pages.forEach((item) => {
    if (isAnalysisOrgPage(item)) {
      item.path = appendOrgUidPath(item.path, orgUid)
    }
    if (item.children && item.children.length) {
      appendOrgUidToAnalysisPages(item.children, orgUid)
    }
  })
  return pages
}

export function hasMenuPath(pages, path) {
  if (!Array.isArray(pages) || !path) return false
  for (let i = 0; i < pages.length; i++) {
    const item = pages[i]
    if (item.path === path) return true
    if (hasMenuPath(item.children, path)) return true
  }
  return false
}

/** 刷新时是否留在当前路由：侧栏菜单不含工作台子应用，要用完整 pages 判断 */
export function canKeepRoutePath(pages, path) {
  if (!path || path === '/home' || path === '/login') return false
  if (hasMenuPath(pages, path)) return true
  if (path === '/workbench' || path.indexOf('/workbench/') === 0) return true
  if (path === '/todoTakas' || path === '/todoTask') return true
  if (path === '/monitoring' || path.indexOf('/monitoring/') === 0) return true
  if (path.indexOf('/systemSettings/attendanceSetting') === 0) return true
  return false
}

/**
 * 小程序页面管理去重：首页与工作台下同名模块只保留一份。
 * 工作台子页面若已在首页出现则去掉；工作台不再含独立模块时隐藏该顶级节点。
 */
export function stripDuplicateAppletPages(pages) {
  if (!Array.isArray(pages) || !pages.length) return pages || []
  const tree = stripRemovedAppletPages(JSON.parse(JSON.stringify(pages)))
  const indexNode = tree.find(
    (item) => item.pageName === '首页' || item.pageName === '数据分析'
  )
  const workbenchNode = tree.find(
    (item) => item.pageName === '工作台' || item.pageName === '业务应用'
  )
  if (!indexNode || !workbenchNode) return tree
  if (indexNode.pageName === '数据分析') return tree
  const indexKeys = {}
  ;(indexNode.children || []).forEach((child) => {
    if (!child) return
    if (child.pageName) indexKeys['n:' + child.pageName] = true
    if (child.pagePath) indexKeys['p:' + child.pagePath] = true
  })
  workbenchNode.children = (workbenchNode.children || []).filter((child) => {
    if (!child) return false
    if (child.pageName && indexKeys['n:' + child.pageName]) return false
    if (child.pagePath && indexKeys['p:' + child.pagePath]) return false
    return true
  })
  if (!(workbenchNode.children && workbenchNode.children.length)) {
    return tree.filter(
      (item) => item.pageName !== '工作台' && item.pageName !== '业务应用'
    )
  }
  return tree
}

export function flattenPageNodes(pages, out) {
  const list = out || []
  const nodes = pages || []
  nodes.forEach((item) => {
    if (!item) return
    list.push(item)
    if (item.children && item.children.length) {
      flattenPageNodes(item.children, list)
    }
  })
  return list
}

function isPageLeaf(node) {
  return !!(node && !(node.children && node.children.length))
}

function pageParentKey(item) {
  if (!item) return ''
  if (item.parentUid) return String(item.parentUid)
  if (item.parent_uid) return String(item.parent_uid)
  return ''
}

/**
 * 权限树回显/保存对齐：
 * Web：uid、班前分析别名、路由 name（禁止裸 path）；
 * 小程序：uid，或「父级 uid + pageName」（与劳务公司初始化取交集一致；禁止裸 pageName/path）。
 */
export function pagesMatchForRightsTree(granted, treeNode) {
  if (!granted || !treeNode) return false
  if (granted.pageUid && granted.pageUid === treeNode.pageUid) return true
  const gName = pageRouteName(granted)
  const tName = pageRouteName(treeNode)
  if (
    PRECLASS_ANALYSIS_NAMES.indexOf(gName) >= 0 &&
    PRECLASS_ANALYSIS_NAMES.indexOf(tName) >= 0
  ) {
    return true
  }
  // Web：只按路由名对齐；不能按 path，报表模板/下级角色等子页会与父级共用 path
  if (gName && tName && gName === tName) return true
  // 小程序页通常无 name/pageCode：用父级+名称，避免「班前教育」「劳务用工」多父级串勾
  const gTitle = pageTitle(granted)
  const tTitle = pageTitle(treeNode)
  const gParent = pageParentKey(granted)
  const tParent = pageParentKey(treeNode)
  if (gTitle && tTitle && gTitle === tTitle && gParent && tParent && gParent === tParent) {
    return true
  }
  return false
}

export function mapGrantedUidsToTreeUids(grantedPages, treePages) {
  const grantedLeaves = flattenPageNodes(grantedPages).filter(isPageLeaf)
  const treeLeaves = flattenPageNodes(treePages).filter(isPageLeaf)
  const treeUids = []
  const treeToGranted = {}
  grantedLeaves.forEach((item) => {
    const uid = item && item.pageUid
    if (!uid) return
    const hit = treeLeaves.find((node) => pagesMatchForRightsTree(item, node))
    const treeUid = hit && hit.pageUid ? hit.pageUid : null
    if (!treeUid) return
    if (treeUids.indexOf(treeUid) < 0) treeUids.push(treeUid)
    if (!treeToGranted[treeUid]) treeToGranted[treeUid] = []
    if (treeToGranted[treeUid].indexOf(uid) < 0) {
      treeToGranted[treeUid].push(uid)
    }
  })
  return { treeUids: treeUids, treeToGranted: treeToGranted }
}

export function resolvePersistPageUid(treeUid, treePages, preferredName, catalogPages) {
  const tree = flattenPageNodes(treePages)
  const node = tree.find((item) => item && item.pageUid === treeUid)
  if (!node) return treeUid
  const route = pageRouteName(node)
  if (!preferredName || PRECLASS_ANALYSIS_NAMES.indexOf(route) < 0) {
    return treeUid
  }
  if (route === preferredName) return treeUid
  const catalog = flattenPageNodes(catalogPages)
  const preferred = catalog.find((item) => pageRouteName(item) === preferredName)
  return preferred && preferred.pageUid ? preferred.pageUid : treeUid
}
